export default {"src":"/_next/static/media/iso-27799.17c54c3a.svg","height":152,"width":152,"blurWidth":0,"blurHeight":0};